<template>

  <div>
    <div v-if="jobType=='input'">
      <br/><h2>手書き入力画面</h2><br/>
    </div>
    <div v-if="jobType=='predict'"><strong>手書き入力画面</strong></div>
    <div>
      <canvas id="draw_canvas" width="352" height="288" @mousemove="drag_draw"></canvas>
      <div class="relativecls inlineblkcls"><canvas id="draw_canvas28" width="28" height="28"></canvas>
        <div class="aicanvas-word"><strong>AI利用<br/>サイズ</strong></div>
      </div>
    </div>
    <div id="answer" v-if="jobType=='input'">
      <br/>
      <b-button variant="outline-primary" class="btnw" @click="cancelImg">Cancel</b-button>
      <b-button variant="outline-primary" class="btnw" @click="setImg">Set</b-button>
      <b-button variant="outline-primary" class="btnw" @click="clear">Clear</b-button>
      <br/>
    </div><div>
      <div id="message_window" class="relativecls margintop">
        <b-button variant="outline-primary" class="clearbtn" v-if="jobType=='predict'" @click="clear">Clear</b-button>
        <div class="dispmes">{{dispMessage}}</div>
      </div>
      <div v-if="jobType=='input'"><br/></div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'inmodalpc',
  props: {
    jobType: { type: String, default: 'input' }
  },
  data () {
    return {
      m_in: 0,
      m_img: 0,
      dispMessage: '文字や図形をマウスで手書きして下さい。',
      canvas: null,
      ctx: null,
      canvas28: null,
      ctx28: null
    }
  },
  computed: {
    ...mapState([ 'setModals' ])
  },
  methods: {
    update_message: function (str) {
      this.dispMessage = str
    },
    clear: function () {
      // this.ctx.fillStyle = 'white'
      // this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      this.ctx28.clearRect(0, 0, this.canvas28.width, this.canvas28.height)
    },
    drag_draw: function (e) {
      if (!e.buttons) return
      const rect = e.target.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      this.draw(x, y)
      this.ctx28.drawImage(this.canvas, 0, 0, this.canvas28.width, this.canvas28.height)
    },
    draw: function (mx, my) {
      const x = mx / this.canvas.clientWidth * this.canvas.width
      const y = my / this.canvas.clientHeight * this.canvas.height
      if (x < 0 || y < 0 || this.canvas.width < x || this.canvas.height < y) return
      const r = 40 / 100.0 * (this.canvas.width / 8) // 線の太さ40
      this.ctx.beginPath()
      this.ctx.fillStyle = 'black'
      this.ctx.arc(x, y, r, 0, Math.PI * 2, true)
      this.ctx.fill()
    },
    setImg: function () {
      var pixels = this.ctx28.getImageData(0, 0, this.canvas28.width, this.canvas28.height)
      for (var y = 0; y < pixels.height; y++) {
        for (var x = 0; x < pixels.width; x++) {
          var i = (y * 4) * pixels.width + x * 4
          // var rgb = parseInt((pixels.data[i] + pixels.data[i + 1] + pixels.data[i + 2]) / 3, 10)
          pixels.data[i] = 255 - pixels.data[i + 3]
          pixels.data[i + 1] = 255 - pixels.data[i + 3]
          pixels.data[i + 2] = 255 - pixels.data[i + 3]
          pixels.data[i + 3] = 255
        }
      }
      this.ctx28.putImageData(pixels, 0, 0)
      this.$store.dispatch('setImage', {
        s_in: this.m_in,
        s_img: this.m_img,
        s_data: this.canvas28.toDataURL()
      })
      /* this.$store.dispatch('setAidata', {
        s_in: this.m_in,
        s_img: this.m_img,
        s_aid: this.ctx28.getImageData(0, 0, this.canvas28.width, this.canvas28.height).data // RGBAデータ：212469文字(カンマ区切りの0,255文字が176*144*4個のテキスト文字数)
      }) */
      /* 背景が黒で白文字時は、ネガポジ変換
      for (let i = 0; i < img.length; i += 4) {
        img[i] = 255 - img[i] // R
        img[i + 1] = 255 - img[i + 1] // G
        img[i + 2] = 255 - img[i + 2] // B
        img[i + 3] = img[i + 3] // A
      }
      const src = []
      for (let i = 0; i < img.length; i += 4) { // 値を格納[255, 255, 0, 0, ...]
        src.push(Math.floor((img[i] + img[i + 1] + img[i + 2]) / 3.0))
      } */
      // 画面をクリア
      this.ctx.fillStyle = 'white'
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
      // 画面を閉じる
      this.cancelImg()
    },
    cancelImg () {
      this.$store.dispatch('dispModalChg', {
        s_in: this.m_in,
        s_img: this.m_img
      })
    }
  },
  created () {
    this.m_in = this.setModals.modalin // Getterはdata()やcomputed()では使えないのでCreate時に代入
    this.m_img = this.setModals.modalimg // Getterはdata()やcomputed()では使えないのでCreate時に代入
    // console.log('modalPc:' + this.m_in + ':' + this.m_img)
  },
  mounted () {
    this.canvas = document.getElementById('draw_canvas')
    this.ctx = this.canvas.getContext('2d')
    this.canvas28 = document.getElementById('draw_canvas28')
    this.ctx28 = this.canvas28.getContext('2d')
  }
}
</script>

<style scoped>
canvas {
  position: relative;
  border: 1px solid #000;
  background: white;
}
.aicanvas-word {
  position: absolute;
  top: -22px;
  right: -4px;
  font-size: 70%;
  line-height: 100%;
}
.dispmes {
  font: outline;
  color: red;
}
.margintop {
  margin: 10px 0 0 0;
}
.clearbtn {
  position: absolute;
  top: -7px;
  right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/InModalPen.vue